<template>
  <span v-if="isWidgetPriceBox">{{ countDownMobileWidgetBoxText }}</span>
  <span v-else>
    <template v-if='parseInt(displayDay) > 0'>{{ ` ${displayDay} ${dayText} : `}}</template>
    {{`${displayHour} ${hourText} : ${displayMinute} ${minText} : ${displaySecond} ${secText}`}}
  </span>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const props = defineProps({
  isWidgetPriceBox: {
    type: Boolean,
    default: false
  }
})
const displayDay = ref()
const displayMinute = ref()
const displayHour = ref()
const displaySecond = ref()
const tripPlanStore = useTripPlanStore()

const showRemainingInterval = ref(null)

const _seconds = computed(() => 1000)
const _minutes = computed(() => {
    return _seconds.value * 60
})
const _hours = computed(() => {
    return _minutes.value * 60
})
const _days = computed(() => {
    return _hours.value * 24
})
const formatTime = (time) => {
    return time < 10 && time !== 0 ? '0' + time : time
}
const dataTrip = computed(() => tripPlanStore.dataTrip)
const timeStart = computed(() => dataTrip.value?.valid_time)

const timer = () => {
  const now = new Date()
  const end = new Date(timeStart.value)
  const distance = end.getTime() - now.getTime()
  if (distance <= 0) {
    clearInterval(showRemainingInterval.value)
    // expired.value = true
    return
  }

  const days = Math.floor(distance / _days.value)
  const hours = Math.floor((distance % _days.value) / _hours.value)
  const minutes = Math.floor((distance % _hours.value) / _minutes.value)
  const seconds = Math.floor((distance % _minutes.value) / _seconds.value)

  displayMinute.value = formatTime(minutes)
  displaySecond.value = formatTime(seconds)
  displayHour.value = formatTime(hours)
  displayDay.value = formatTime(days)
}

const dayText = computed(() => {
    return ((parseInt(displayDay.value) === 0) || (parseInt(displayDay.value) === 1)) ? 'day' : 'days'
})

const hourText = computed(() => {
    return ((parseInt(displayHour.value) === 0) || (parseInt(displayHour.value) === 1)) ? 'hour' : 'hours'
})

const minText = computed(() => {
    return ((parseInt(displayMinute.value) === 0) || (parseInt(displayMinute.value) === 1)) ? 'min' : 'mins'
})

const secText = computed(() => {
    return ((parseInt(displaySecond.value) === 0) || (parseInt(displaySecond.value) === 1)) ? 'sec' : 'secs'
})

const countDownMobileWidgetBoxText =  computed(() =>`${displayDay.value} d : ${displayHour.value} h : ${displayMinute.value} m : ${displaySecond.value} s`)

onMounted(() => {
    timer()
    showRemainingInterval.value = setInterval(timer, 1000)
})

onUnmounted(() => {
    clearInterval(showRemainingInterval.value)
})
</script>

<style lang="scss" scoped></style>
